export default "__VITE_ASSET__BRYKRQPz__"